import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Accordion,
  ListGroup,
  Button,
} from "react-bootstrap";

const Learmores = () => {
  const [activeKey, setActiveKey] = useState("0"); // default open

 const handleSelect = (key) => {
  setActiveKey(key);
  // bas accordion toggle hoga, scroll bilkul nhi hoga
};

  return (
     <Container className="py-5">
      {/* Page Header */}
      <div className="mb-4 text-center" style={{ paddingTop: "75px" }}>
        <h1 className="display-6 fw-semibold mb-2">Learn more</h1>
        <p className="text-muted mb-0">
          Linked information for each section uses your existing content.
        </p>
      </div>

      <Row className="g-4">
        {/* Sidebar */}
        <Col xs={12} lg={3}>
          <div className="sidebar-links">
            <ListGroup variant="flush" className="small">
              <ListGroup.Item
                action
                onClick={() => handleSelect("0")}
                style={{
                  color: activeKey === "0" ? "#FFA500" : "inherit",
                  fontWeight: activeKey === "0" ? "600" : "normal",
                }}
              >
                What is Share-Circle
              </ListGroup.Item>

              <ListGroup.Item
                action
                onClick={() => handleSelect("1")}
                style={{
                  color: activeKey === "1" ? "#FFA500" : "inherit",
                  fontWeight: activeKey === "1" ? "600" : "normal",
                }}
              >
                Borrow
              </ListGroup.Item>

              <ListGroup.Item
                action
                onClick={() => handleSelect("2")}
                style={{
                  color: activeKey === "2" ? "#FFA500" : "inherit",
                  fontWeight: activeKey === "2" ? "600" : "normal",
                }}
              >
                Community Support Partner (CSP)
              </ListGroup.Item>

              <ListGroup.Item
                action
                onClick={() => handleSelect("3")}
                style={{
                  color: activeKey === "3" ? "#FFA500" : "inherit",
                  fontWeight: activeKey === "3" ? "600" : "normal",
                }}
              >
                Register as a CSP
              </ListGroup.Item>

              <ListGroup.Item
                action
                onClick={() => handleSelect("4")}
                style={{
                  color: activeKey === "4" ? "#FFA500" : "inherit",
                  fontWeight: activeKey === "4" ? "600" : "normal",
                }}
              >
                Lightning (LN)
              </ListGroup.Item>
            </ListGroup>
          </div>
        </Col>

        {/* Main Content */}
        <Col xs={12} lg={9}>
          <Accordion activeKey={activeKey} onSelect={setActiveKey} alwaysOpen>
            {/* What is Share-Circle */}
            <Accordion.Item eventKey="0" id="0">
              <Accordion.Header>What is Share-Circle</Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li>Bitcoin Community Leaders & Share-Circle enable efficient, low-cost local lending.</li>
                  <li>Share-Circle is a registered charity.</li>
                  <li>It enables the delivery of 0% interest, microfinance loans to the unbanked globally.</li>
                  <li>Using Bitcoin and Lightning it enables money-transfer efficiencies not available with conventional currencies.</li>
                  <li>It is an online platform with an efficient, scalable, community lending model.</li>
                  <li>The platform and service are built around Community Support Partners (CSPs).</li>
                  <li>There is a transparent 10% Community Support Partner (CSP) contribution.</li>
                  <li>This provides a way to incentivise, support and reward CSPs for being accessible, responsible lending associates.</li>
                  <li>It uses a simple, mobile-based digital solution for repaying loans – saving borrowers time, travel and costs.</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            {/* Borrow */}
            <Accordion.Item eventKey="1" id="1">
              <Accordion.Header>Borrow</Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li>By being a responsible borrower, you enable others to thrive also.</li>
                  <li>The Share-Circle Borrow service is available where you have an authorised CSP.</li>
                  <li>These will initially be where a local person is familiar with Bitcoin and Lightning and has joined Share-Circle as a Lending Partner (CSP).</li>
                  <li>If there is no local authorised CSP, you can talk to a responsible local community support organisation, ask if they are familiar with Bitcoin, and whether they could join the Share-Circle Community Support Partner (CSP) programme.</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            {/* CSP */}
            <Accordion.Item eventKey="2" id="2">
              <Accordion.Header>Community Support Partner (CSP)</Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li>Bitcoin community leaders and Share-Circle enable efficient, low-cost local lending.</li>
                  <li>Community Support Partners (CSPs) are Bitcoin-aware local people who want to enable responsible local borrowing and lending in their community.</li>
                  <li>Share-Circle CSPs are central to the overall service.</li>
                  <li>As a Bitcoin-aware community leader, you understand the benefits of Bitcoin and Lightning.</li>
                  <li>You understand the needs of people in your community and have established relationships.</li>
                  <li>We are both on a mission to help Bitcoin communities grow.</li>
                  <li>Similar to taxi drivers with Uber, you are motivated and responsible, supporting the growth of Bitcoin education and usage as well as enabling growth of your local economy.</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            {/* Register as a CSP */}
            <Accordion.Item eventKey="3" id="3">
              <Accordion.Header>Register as a CSP</Accordion.Header>
              <Accordion.Body>
                <ol>
                  <li>To apply to be a CSP, you need to register.</li>
                  <li>You can then fill out an application form.</li>
                  <li>One of our team will contact you to discuss the process.</li>
                  <li>This process ensures you and your team meet Share-Circle (SC) criteria for effectively becoming a community lending partner.</li>
                  <li>If you do not meet these criteria initially, we may provide recommendations on what you or your community team need to do to become a CSP.</li>
                  <li>Once accepted, you can start registering your entrepreneurs for supported crowdfunded loans.</li>
                </ol>
                <div className="d-flex gap-2 mt-3">
                  <button className=" btn btn-warning" href="/CSP">Register now</button>
                  <Button variant="outline-secondary" href="/CSP">Read CSP FAQ</Button>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* Lightning (LN) */}
            <Accordion.Item eventKey="4" id="4">
              <Accordion.Header>Lightning (LN)</Accordion.Header>
              <Accordion.Body>
                <ul>
                  <li>Lightning is a proven technology built on Bitcoin.</li>
                  <li>It allows users to send and receive bitcoin easily.</li>
                  <li>As easy as sending a text from your mobile phone.</li>
                  <li>The process of repaying your loan should be easy and not require you to travel or waste time.</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default Learmores;
